import { default as fo_eu } from '@deliveryhero/pd-bento-design-tokens/web/js/fo-eu';
import fp from '@deliveryhero/pd-bento-design-tokens/web/js/fp';
import ys from '@deliveryhero/pd-bento-design-tokens/web/js/ys';

import { BrandCodeEnum, BrandCodes } from './types';

// To do: Refactor this into a hook file. Complete after merging all the dependent PRs

export const getColorTokens = (brandCode: BrandCodes) => {
  switch (brandCode) {
    case BrandCodeEnum.fp:
      return fp;

    case BrandCodeEnum.fo:
      return fo_eu;

    case BrandCodeEnum.ys:
      return ys;

    default:
      return fp;
  }
};
